var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C17.4706 3 21.5 7.02944 21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3ZM12.5 5C8.63401 5 5.5 8.13401 5.5 12C5.5 15.866 8.63401 19 12.5 19C16.366 19 19.5 15.866 19.5 12C19.5 8.13401 16.366 5 12.5 5ZM14.8438 9.24512C15.2259 8.91206 15.8058 8.91645 16.1836 9.27051C16.5612 9.62454 16.6032 10.2026 16.2959 10.6055L16.2295 10.6836L12.4795 14.6836C12.132 15.0542 11.5671 15.1026 11.1641 14.8105L11.0859 14.7471L8.83594 12.7471L8.7627 12.6758C8.41973 12.3025 8.40891 11.723 8.75293 11.3359C9.09699 10.9489 9.67404 10.8915 10.085 11.1885L10.1641 11.2529L11.6855 12.6055L14.7705 9.31641L14.8438 9.24512Z",
    fill: "#700AC1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.0f016bd53e62f879cfec7f4d2895fa3b.svg";
export { ForwardRef as ReactComponent };